import { useEffect, useRef } from 'react';

const useSocketEvent = (socket, event, handler) => {
    const handlerRef = useRef(handler);

    useEffect(() => {
        handlerRef.current = handler;
    }, [handler]);

    useEffect(() => {
        if (!socket || !event) return undefined;
        const wrapper = (...args) => handlerRef.current?.(...args);
        socket.on(event, wrapper);
        return () => {
            socket.off(event, wrapper);
        };
    }, [socket, event]);
};

export default useSocketEvent;
